define('viewmodels/pages/player/valuables',[
    'knockout',
    'underscore'
], function (ko, _) {

    var ValuablesViewModel = function(session, adventurers, itemManager, getField, playerTabs, tournamentCampaigns) {
        var self = this;

        self.subNav = playerTabs;

        self.meta = {
            title: getField('meta_title'),
            description: getField('meta_description')
        };

        self.cmsTexts = {
            use: getField('label_use'),
            noValuables: getField('no_valuables'),
            yourValuables: getField('your_valuables')
        };

        self.itemManager = itemManager;
        self.playerIdOrCasumoName = ko.observable().withFallback(session.id);

        self.tournamentCampaigns = tournamentCampaigns;
        self.isCurrentPlayerOptedIntoNext = tournamentCampaigns.activeCampaign.property('nextTournament').property('currentPlayerOptedIn').orElse(false);


        self.adventurer = ko.deferredComputed(function() {
            return adventurers.getByPlayerIdOrCasumoName(self.playerIdOrCasumoName());
        });

        self.usableItems = ko.deferredComputed(function() {
            return self.adventurer().getAdventure().freshOrUsedEarnedItemsByPriority();
        });

        self.hasItems = ko.deferredComputed(function() {
            return self.usableItems().length > 0;
        });
    };

    return ValuablesViewModel;
});


